import { render, staticRenderFns } from "./About.vue?vue&type=template&id=039c5b43"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/websites/streamlined-business-solutions/sbs-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('039c5b43')) {
      api.createRecord('039c5b43', component.options)
    } else {
      api.reload('039c5b43', component.options)
    }
    module.hot.accept("./About.vue?vue&type=template&id=039c5b43", function () {
      api.rerender('039c5b43', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/About.vue"
export default component.exports